export function replaceConsecutiveTwoOrMoreSpace(originalValue) {
  let result = originalValue
  const replaceTargets = [...originalValue.matchAll(/{{{(.*?)}}}/g)]
  for (const replaceTarget of replaceTargets) {
    const originalPart = replaceTarget[0]
    const innerValue = replaceTarget[1]
    const newValue = innerValue.replace(/( {2,})/g, (spacePart) => {
      return spacePart
        .split('')
        .map((char, index) => (index % 2 === 1 ? '&nbsp;' : char))
        .join('')
    })
    result = result.replace(originalPart, `{{{${newValue}}}}`)
  }
  return result
}
